import React from "react"
import { defineMessages, injectIntl } from "react-intl"
import { ConnectedProps, connect } from "react-redux"
import Icon from "../../common/icon/icon.component.jsx"
import ItemSKU from "../../common/quote/component/ItemSKU"
import ItemLineDescription from "../../common/quote/component/itemLineDescription"
import QuoteItemInternalNotesEdit from "../../common/quote/iteminternalnotes.component.jsx"
import SerialNumberLabelListing from "../../product/serial-number/SerialNumberLabelListing"
import ItemCustomAttributesDisplay from "../../quote/ItemCustomAttributesDisplayComponent"
import { Settings, SupportedSettings } from "../../settings/account/Settings.jsx"
import { DOCUMENT_TYPE } from "../../state/Constants"
import IntlProps from "../../state/helpers/IntlProps"
import { LocationDto } from "../../state/location/Location"
import { AdviceDto } from "../../state/pricing/Advice"
import { PricingFeeCalculationDto } from "../../state/pricing/PricingFeeCalculation"
import { PricingRowDto } from "../../state/pricing/PricingRow"
import { TOOGGLE_DESCRIPTION_TYPE } from "../../state/pricing/ProductDescription"
import { patchPricingTableItem } from "../../state/pricing/actions"
import { getPricingTableItem } from "../../state/pricing/selectors"

const messages = defineMessages({
    "incompatible_rule_label": {
        id: "quote.edit.advices.incompatible_label",
        defaultMessage: "{subjectProductTitle} is not compatible with {objectProductTitle}",
    }
})

type OwnProps = {
    productDescription: TOOGGLE_DESCRIPTION_TYPE
    type: DOCUMENT_TYPE
    allowEdit: boolean
    itemId: string
    mainObjectId: string
    editableNotes?:boolean
    item: PricingRowDto | null
    fees: PricingFeeCalculationDto[]
    advice?: AdviceDto
    location: LocationDto
}


const ProductInformation = (props: Props & IntlProps) => {
    let warning = <></>
    if (props.advice) {
        warning = <span className={"ml-2"} data-toggle="tooltip"
            data-placement="top"
            title={props.intl.formatMessage(messages["incompatible_rule_label"], {
                subjectProductTitle: props.advice.attributes.subjectProductTitle,
                objectProductTitle: props.advice.attributes.objectProductTitle,
            })}
        >
            <Icon value={"exclamation-circle"} className={"text-danger"} />
        </span>
    }

    const serialNumbers = props.item?.attributes.serialNumbers
    const internalNotes = props.item?.attributes.internalNotes
    return (
        <div className="flex-row w-100">
            <div className="d-inline-flex w-100">
                <div className={"d-flex px-2 flex-wrap"} >
                    <div className="d-flex flex-wrap">
                        {props.item &&
                            <QuoteItemInternalNotesEdit
                                type={props.type}
                                editable={props.allowEdit || (props.editableNotes || false)}
                                location={props.location}
                                className={"mt-1 "}
                                itemId={props.itemId}
                                mainObjectId={props.mainObjectId}
                            />}

                    </div>
                </div>

                <div id="itemLineDescription" className={"d-flex align-items-center w-100"}>
                    <div className="w-100">
                        <ItemLineDescription
                            productDescription={props.productDescription}
                            type={props.type}
                            editable={props.allowEdit}
                            itemId={props.itemId}
                            mainObjectId={props.mainObjectId}
                        />
                        {Settings.get(SupportedSettings.ShowSKUInPricingTable) && props.item?.attributes.itemObject.attributes.sku &&
                            <ItemSKU SKU={props.item?.attributes.itemObject.attributes.sku}/>
                        }
                        <SerialNumberLabelListing serialNumbers={serialNumbers}/>

                        <div className="d-inline-flex" style={{overflowWrap:"anywhere"}}>
                            <ItemCustomAttributesDisplay
                                isLoading={false}
                                item={props.item}
                            />
                        </div>

                    </div>
                    {warning}
                </div>

            </div>
            {internalNotes &&
                <div className={"w-100 px-2 py-1 blockquote ml-2 mb-0"}>
                    {internalNotes.split("\n").map((v, i) => <p key={i}
                        className={"m-0"}>
                        <small><em>{v}</em></small>
                    </p>)}
                </div>}
        </div>
    )
}

const mapState = (state, props: OwnProps) => {
    const id = props.itemId
    const objectId = props.mainObjectId
    const item = getPricingTableItem(state, id, objectId)
    return {
        ...props,
        item: item,
    }
}
const mapDispatch = { patchPricingTableItem }
const connector = connect(mapState, mapDispatch)
type Props = ConnectedProps<typeof connector>
export default connector(injectIntl(ProductInformation))



// WEBPACK FOOTER //
// ./src/pricing/components/ProductInformationComponent.tsx